import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay, FreeMode } from 'swiper/modules';


// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/free-mode';

// Import all creme images
import cm1 from '../../../assets/assets-home/img/creme/1.png';
import cm2 from '../../../assets/assets-home/img/creme/2.jpeg';
import cm3 from '../../../assets/assets-home/img/creme/3.png';
import cm4 from '../../../assets/assets-home/img/creme/4.png';
import cm5 from '../../../assets/assets-home/img/creme/5.png';
import cm6 from '../../../assets/assets-home/img/creme/6.webp';
import cm7 from '../../../assets/assets-home/img/creme/7.png';
import cm8 from '../../../assets/assets-home/img/creme/8.png';
import cm9 from '../../../assets/assets-home/img/creme/9.png';

const CremeSection = () => {
  const { t } = useTranslation('home');
  // Array of imported images for the slider
  const cremeImages = [
    cm5, cm1, cm4, cm3, cm2, cm6, cm7, cm8, cm9
  ];

  return (
    <div className="creme lg:!my-[60px] sm:!my-10 !my-8">
      <div className="mx-auto w-full max-w-[1500px] px-5 sm:px-6 lg:px-10">
        <h2 className="section-heading text-white text-center mb-6 sm:mb-8 lg:mb-10">
          <Trans
            i18nKey="creme.heading"
            ns="home"
            components={{ br1: <br className='sm:hidden' /> }}
          />
        </h2>

        <Swiper
          loop={true}
          freeMode={true}
          speed={4000}
          modules={[Pagination, Autoplay, FreeMode]}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
            stopOnLastSlide: false,
            reverseDirection: false
          }}
          pagination={{
            el: '.creme_pagination',
            clickable: true
          }}
          breakpoints={{
            0: {
              spaceBetween: 14,
              slidesPerView: 'auto',
              speed: 4000
            },
            640: {
              spaceBetween: 36,
              slidesPerView: 'auto',
              speed: 4000
            },
            1024: {
              spaceBetween: 72,
              slidesPerView: 'auto',
              speed: 4000
            }
          }}
          className="creme_slider"
        >
          {cremeImages.map((image, index) => (
            <SwiperSlide key={index} className='w-fit'>
              <div className="creme_item">
                <img src={image} alt={t('creme.altPartner', { index: index + 1 })} className='w-full h-auto max-w-[65%]' />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="pagination creme_pagination"></div>
      </div>
    </div>
  );
};

export default CremeSection;